import React, { useEffect, useState } from 'react';

const ProgressBar = ({ progress, currentStep, totalSteps, categoryInfo, categories }) => {
  const [animatedProgress, setAnimatedProgress] = useState(progress);
  
  // Animate progress when it changes - without backing off
  useEffect(() => {
    // Just animate directly to the new value without resetting
    const timer = setTimeout(() => {
      setAnimatedProgress(progress);
    }, 10);
    return () => clearTimeout(timer);
  }, [progress]);

  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      {/* Premium progress container */}
      <div className="relative h-2 bg-blue-50 rounded-full overflow-hidden shadow-inner">
        {/* Gradient progress fill with animation */}
        <div 
          className="h-full bg-gradient-to-r from-blue-400 to-blue-600 transition-all duration-1000 ease-out"
          style={{ width: `${animatedProgress}%` }}
        >
          {/* Animated shine effect */}
          <div className="absolute inset-0 overflow-hidden">
            <div 
              className="h-full w-20 bg-white opacity-20 transform -skew-x-20 animate-shine"
              style={{
                animation: 'shine 2s infinite linear',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
                left: '-100%',
              }}
            ></div>
          </div>
        </div>
        
        {/* Percentage tick marks (every 20%) */}
        <div className="absolute inset-0 flex items-center">
          {[20, 40, 60, 80].map((percent) => (
            <div 
              key={percent}
              className={`absolute h-2 w-0.5 ${
                animatedProgress >= percent ? 'bg-white opacity-40' : 'bg-blue-200 opacity-30'
              }`}
              style={{ left: `${percent}%` }}
            ></div>
          ))}
        </div>
      </div>
      
      {/* Progress information */}
      <div className="flex justify-between mt-2 text-xs font-medium">
        <div className="text-blue-600">
          <span className="bg-blue-50 px-2 py-0.5 rounded-md">{categoryInfo.questionInCategory} / {categoryInfo.totalQuestionsInCategory}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="h-1 w-3 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
          <span className="text-blue-600 font-medium">{Math.round(progress)}% 完成</span>
        </div>
      </div>
      
      {/* Add keyframes for shine animation */}
      <style jsx>{`
        @keyframes shine {
          0% {
            left: -100%;
          }
          100% {
            left: 200%;
          }
        }
      `}</style>
    </div>
  );
};

export default ProgressBar;